import { Instance, types } from 'mobx-state-tree';

const FundInfo = types.model({
  clabe: '',
  reference: '',
  amount: types.optional(types.union(types.number, types.string), ''),
  currency: '',
  bank: '',
  beneficiaryName: '',
});

export interface FundInfoStore extends Instance<typeof FundInfo> {}
export default FundInfo;
